import type { Resource } from '../../';
export const country_countries_SE: Resource = {"default":"Sweden"};
